import React from 'react';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _map from 'lodash/map';
import { DataList, formatListData } from 'commons-ui';

import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';

import { actions } from '../../actions/buckets';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { bucketsConfig, DEFAULT_CONFIG } from './bucketsConfig';

const useBuckets = () => {
	const location = useLocation();

	const getBucketsData = () => {
		const buckets = _get(location, ['state', 'rowData', 'buckets']);
		const data = _map(Object.entries(buckets), ([key, value]) => ({ ...(value as object), id: key }));
		return { rowCount: data?.length, data: formatListData(data) };
	};

	const { getActionHandler } = useDashboardActions(makeActionHandler, makeActionList);

	return { getBucketsData, getActionHandler };
};

const Conversions: React.FC<{}> = () => {
	const { getBucketsData, getActionHandler } = useBuckets();
	return (
		<div>
			<DataList
				fetchData={getBucketsData}
				columnConfigs={bucketsConfig}
				defaults={DEFAULT_CONFIG}
				actions={actions}
				getActionHandler={getActionHandler}
				disableColumnFilter
				entity={LIST_ENTITY_NAMES.COUPON_CONVERSIONS}
			/>
		</div>
	);
};

export default Conversions;
